import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminCustomerList() {

  
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
  const [booksPerPage, setBooksPerPage] = useState(10); // Default rows per page

  const exportToExcel = () => {
    if (books.length === 0) {
      alert("No data to export!");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      books.map(({ id, name, username, createdAt }) => {
        const date = new Date(createdAt);
  
        // Format the date and time just like you're doing in the table
        const formattedDate = date.toLocaleDateString('en-US'); // Format: MM/DD/YYYY
        const formattedTime = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }); // Format: HH:mm:ss
  
        return {
          "Customer ID": id,
          "Name": name,
          "Mobile": username,
          "Date Created": formattedDate,
          "Time Created": formattedTime,
        };
      })
    );
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
  
    // Save the Excel file
    XLSX.writeFile(workbook, "Customers_List.xlsx");
  };
  
  useEffect(() => {
    fetch(`${apiUrl}/public/getallusers`)
    .then(response => response.json())
    .then(data => {
      console.log("API Data:", data); // Debugging: Check API response
      setBooks(data.reverse());
      setLoading(false);
    })
    .catch(error => {
      console.error('Error fetching users:', error);
      setLoading(false);
    });
  
  }, []);

  
  const [searchTerm, setSearchTerm] = useState("");
  // Filter books based on search term
const filteredBooks = books.filter(book =>
  (book.name && book.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  (book.username && book.username.toLowerCase().includes(searchTerm.toLowerCase()))
);


  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);


  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
<>
    <Flex h="100%" bg="gray.100">
      <AdminSidebar />
      <Box flex="1" p={4}>
        <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
          <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
          <Text fontSize="xl" fontWeight="bold">
          Customers List
          </Text>
          <Button colorScheme="teal" onClick={exportToExcel} mb={4}>
  Download Excel
</Button>
        </Flex>



        <Box p={3}>


  <FormControl id="search">
    <FormLabel>Search Customers</FormLabel>
<Input
  type="text"
  placeholder="Search..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  width="800px"
  mb="5"
  bg="white"
  borderColor="gray.300"
  borderRadius="md"
  padding="10px"
  fontSize="md"
  color="gray.600"
  _placeholder={{ color: "gray.400" }}
  _focus={{ borderColor: "teal.500", boxShadow: "md" }}
/>
  </FormControl>

  {loading ? (
    <Center>
      <Spinner size="sm" />
    </Center>
  ) : (
    <>
      <Flex justify="space-between" mb={4}>
        <Select
          width="150px"
          value={booksPerPage}
          onChange={(e) => {
            setBooksPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="50">50 per page</option>
        </Select>
        <h1>Total Customers: {currentBooks.length}</h1>
      </Flex>
 

      {/* Enable Horizontal Scroll */}
      <Box overflowX="auto">
        <TableContainer>
          <Table variant="striped" colorScheme="teal" minWidth="800px">
            <Thead>
              <Tr>
                <Th>Customer ID</Th>
                <Th>Name</Th>
                <Th>Mobile</Th>
                <Th>Date Created</Th>
                <Th>Time Created</Th>
              </Tr>
            </Thead>
            <Tbody>
            {currentBooks.map((book) => {
      const date = new Date(book.createdAt);
      const formattedDate = date.toLocaleDateString('en-US'); // Format: MM/DD/YYYY
      const formattedTime = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Format: HH:mm:ss

      return (
        <Tr key={book.id}>
          <Td>{book.id}</Td>
          <Td>{book.name}</Td>
          <Td>{book.username}</Td>
          <Td>{formattedDate}</Td>
          <Td>{formattedTime}</Td>
        </Tr>
      );
    })}

            </Tbody>
          </Table>
        </TableContainer>
      </Box>

      <Flex justify="space-between" mt={4}>
        <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
          Previous
        </Button>
        <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
          Next
        </Button>
      </Flex>
    </>
  )}
</Box>




      </Box>

    </Flex>

 

</>
    
  );
}

export default AdminCustomerList;
